var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.00068C16.7554 6.2409 15.9391 4.61034 14.6766 3.36018C13.4142 2.11001 11.7758 1.3096 10.0137 1.08224C8.25159 0.85487 6.46362 1.21316 4.9252 2.10193C3.38678 2.99069 2.18325 4.36062 1.5 6.00068M1 2.00068V6.00068H5M1 10.0007C1.24456 11.7605 2.06093 13.391 3.32336 14.6412C4.58579 15.8914 6.22424 16.6918 7.98633 16.9191C9.74841 17.1465 11.5364 16.7882 13.0748 15.8994C14.6132 15.0107 15.8168 13.6407 16.5 12.0007M17 16.0007V12.0007H13",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/Sync.18ae8e8537a0032ebbfd12c25e991210.svg";
export { ForwardRef as ReactComponent };